import React from "react";
import Navbar from "../components/Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faMapMarker,
  faPhone,
} from "@fortawesome/free-solid-svg-icons";
import Map from "../components/Map";
import Footer from "../components/Footer";

const Reservation = () => {
  const countryOptions = [
    "Destination",
    "Italy",
    "France",
    "Switzerland",
    "Thailand",
    "Australia",
    "Pakistan",
    "Indonesia",
    "Malaysia",
    "Singapore",
  ];
  return (
    <div>
      <Navbar />
      <section
        style={{
          backgroundImage: `url(${"https://templatemo.com/templates/templatemo_580_woox_travel/assets/images/heading-bg-02.jpg"})`,
        }}
        className="text-gray-200 h-[110vh] bg-cover bg-no-repeat bg-center flex flex-col items-center justify-center"
      >
        <p className="font-semibold text-xl">Book Prefered Deal Here</p>
        <div className="h-[2px] w-[100px] bg-gray-500 mt-3"></div>
        <h1 className="text-6xl font-bold mt-4 text-center">
          Make Your Reservation
        </h1>
        <p className="w-[90%] md:w-[60%] text-center mt-6">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt uttersi labore et dolore magna aliqua is
          ipsum suspendisse ultrices gravida
        </p>
        <button className="bg-gray-200 mt-5  text-gray-800  w-[auto]  hover:bg-cyan-500  border  hover:border-cyan-500  hover:text-gray-200 transition-all    text-center py-3 px-8 rounded-3xl md:rounded-full font-medium md:font-semibold">
          Discover More
        </button>
      </section>
      <section className="bg-gray-800">
        <div className="px- md:px-16 flex flex-col md:flex-row justify-center items-center">
          <div className="bg-gray-200 h-48 mx-3 mt-[-100px] z-40 text-gray-700 w-[90%] md:w-[28%] flex flex-col items-center justify-center p-6 rounded-3xl">
            <FontAwesomeIcon
              className="text-cyan-500 bg-gray-300 p-6 rounded-full"
              icon={faPhone}
            />
            <h1 className="mt-4 font-bold text-xl text-center">
              Make a Phone Call
            </h1>
            <p className="text-cyan-500 mt-2 text-center">+123 456 789 (0)</p>
          </div>
          <div className="bg-gray-200 h-48 mx-3 mt-5 md:mt-[-100px] z-40 text-gray-700 w-[90%] md:w-[28%] flex flex-col items-center justify-center p-6 rounded-3xl">
            <FontAwesomeIcon
              className="text-cyan-500 bg-gray-300 p-6 rounded-full"
              icon={faEnvelope}
            />
            <h1 className="mt-4 font-bold text-center text-xl">
              Visit Our Offices
            </h1>
            <p className="text-cyan-500 mt-2 text-center">
              24th Street North Avenue London, UK
            </p>
          </div>
          <div className="bg-gray-200 h-48 mx-3 mt-5 md:mt-[-100px] z-40 text-gray-700 w-[90%] md:w-[28%] flex flex-col items-center justify-center p-6 rounded-3xl">
            <FontAwesomeIcon
              className="text-cyan-500 bg-gray-300 p-6 rounded-full"
              icon={faMapMarker}
            />
            <h1 className="mt-4 font-bold text-center text-xl">
              Contact Us via Email
            </h1>
            <p className="text-cyan-500 mt-2 text-center">company@email.com</p>
          </div>
        </div>
        <div className="px-4 md:px-8   py-16">
          <Map />
          <div className="bg-gray-200 rounded-b-3xl mt-[-50px] pt-[50px]">
            <h1 className="text-4xl text-center text-gray-800 font-semibold px-5 mt-10">
              Make Your Reservation Through This Form
            </h1>
            <form className="flex flex-col items-center mt-16 px-5 md:px-16">
              <div className="flex flex-col md:flex-row w-full ">
                <div className="flex flex-col justify-center w-full md:w-[50%]">
                  <label className="text-gray-500">Your Name</label>
                  <input
                    type="text"
                    placeholder="Ex: John Smith"
                    className="px-8 py-3 bg-transparent border rounded-3xl border-gray-400"
                  />
                </div>
                <div className="flex flex-col justify-center ml-0 md:ml-5 w-full md:w-[50%]">
                  <label className="text-gray-500">Your Phone Number</label>
                  <input
                    type="text"
                    placeholder="Ex. +xxx xxx xxx"
                    className="px-8 py-3 bg-transparent border rounded-3xl border-gray-400"
                  />
                </div>
              </div>
              <div className="flex  flex-col md:flex-row mt-2 md:mt-5 w-full">
                <div className="flex flex-col justify-center w-full md:w-[50%]">
                  <label className="text-gray-500">Number Of Guests</label>
                  <input
                    type="text"
                    placeholder="ex. 3 or 4 or 5"
                    className="px-8 py-3 bg-transparent border rounded-3xl border-gray-400"
                  />
                </div>
                <div className="flex flex-col justify-center ml-0 md:ml-5 w-full md:w-[50%]">
                  <label className="text-gray-500">Check In Date</label>
                  <input
                    type="date"
                    placeholder="Ex. +xxx xxx xxx"
                    className="px-8 py-3 bg-transparent border rounded-3xl w-full border-gray-400"
                  />
                </div>
              </div>
              <div className="flex flex-col mt-5 w-full">
                <label className="text-gray-500">Choose Your Destination</label>
                <select className="mt-2 px-5 py-2 bg-transparent border w-full border-gray-400 rounded-3xl">
                  {countryOptions.map((option,index)=>(
                    <option key={index}>{option}</option>
                  ))}
                </select>
              </div>
              <button className="bg-cyan-500 mt-5  text-gray-200  w-full  hover:bg-cyan-600  border  hover:border-cyan-500  hover:text-gray-200 transition-all    text-center py-3 px-8 rounded-3xl md:rounded-full font-medium md:font-semibold mb-10">
          Make Your Reservation Now
        </button>
            </form>
          </div>
        </div>
      </section>
      <Footer/>
    </div>
  );
};

export default Reservation;
